module.exports = __webpack_public_path__ + "media/range-hero.0083e2ee.mp4";